// English translations for the covers page (French string -> English).
const m: Record<string, string> = {
  'Couvertures — Admin Storiz': 'Covers — Storiz Admin',
  'Bibliothèque de couvertures': 'Cover library',
  '{n} couverture': '{n} cover',
  '{n} couvertures': '{n} covers',
  '{n} couverture pour « {q} »': '{n} cover for “{q}”',
  '{n} couvertures pour « {q} »': '{n} covers for “{q}”',
  '+ Ajouter une couverture': '+ Add a cover',
  'Rechercher un design (nom, slug, tags)...': 'Search a design (name, slug, tags)...',
  // Sort options
  'Populaires': 'Popular',
  'Plus récents': 'Newest',
  'Plus anciens': 'Oldest',
  'Dernière modification': 'Last modified',
  // Category tabs
  'Toutes': 'All',
  // Empty states
  'Aucun design trouvé pour « {q} »': 'No design found for “{q}”',
  'Aucune couverture': 'No covers',
  'Essayez un autre mot-clé ou effacez la recherche': 'Try another keyword or clear the search',
  'Ajoutez votre première couverture pour commencer': 'Add your first cover to get started',
  'Effacer la recherche': 'Clear search',
  // Cover card
  'Masquée': 'Hidden',
  'Masquer': 'Hide',
  'Afficher': 'Show',
};
export default m;
